import React from "react";
import "./Heading.scss";

export default function Heading(props: { content: string }) {
  return (
    <div className="heading">
      <h2 className="heading__text">{props.content}</h2>
      <hr className="heading__line" />
    </div>
  );
}
